export enum QueueNames {
  STRIPE_WEBHOOKS = 'stripe-webhooks',
  STRIPE_RECONCILIATION = 'stripe-reconciliation',
  SUBSCRIPTION_EXPIRATION = 'subscription-expiration',
  DISPATCHER_TICK = 'dispatcher-tick',
  EMAIL_SENDING = 'email-sending',
  SMS_SENDING = 'sms-sending',
  ZAMMAD_WEBHOOKS = 'zammad-webhooks',
  ZAMMAD_RECONCILIATION = 'zammad-reconciliation',
  PROPERTY_ENRICHMENT = 'property-enrichment',
  USER_REGISTRATIONS_CLEANUP = 'user-registrations-cleanup',
  USER_SESSIONS_CLEANUP = 'user-sessions-cleanup',
  TOKEN_VAULTS_EXPIRATION = 'token-vaults-expiration',
  AGENT_CARDS_EXPIRATION = 'agent-cards-expiration',
  AGENT_CARDS_SYNC = 'agent-cards-sync',
  PROPERTY_APPLICATIONS_EXPIRATION = 'property-applications-expiration',
}
